import React from 'react';

import { SVGProps } from './SVGProps';

const DashboardToolIcon = ({ fill = '#101828', width = '24', height = '25' }: SVGProps) => {
  return (
    <svg width={width} height={height} viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.6314 7.76809C15.2353 7.37207 15.0373 7.17406 14.9631 6.94574C14.8979 6.74489 14.8979 6.52854 14.9631 6.3277C15.0373 6.09937 15.2353 5.90136 15.6314 5.50535L18.4697 2.66698C17.7165 2.32634 16.8804 2.13672 16 2.13672C12.6863 2.13672 9.99998 4.82301 9.99998 8.13672C9.99998 8.62776 10.059 9.10502 10.1702 9.56181C10.2894 10.051 10.349 10.2955 10.3384 10.45C10.3273 10.6118 10.3032 10.6979 10.2286 10.8418C10.1574 10.9793 10.0208 11.1159 9.7478 11.3889L3.49998 17.6367C2.67156 18.4651 2.67156 19.8083 3.49998 20.6367C4.32841 21.4651 5.67156 21.4651 6.49998 20.6367L12.7478 14.3889C13.0208 14.1159 13.1574 13.9793 13.2949 13.9081C13.4388 13.8335 13.5249 13.8094 13.6867 13.7983C13.8412 13.7877 14.0857 13.8473 14.5749 13.9665C15.0317 14.0777 15.5089 14.1367 16 14.1367C19.3137 14.1367 22 11.4504 22 8.13672C22 7.25631 21.8104 6.42019 21.4697 5.66698L18.6314 8.50535C18.2353 8.90136 18.0373 9.09937 17.809 9.17356C17.6082 9.23882 17.3918 9.23882 17.191 9.17356C16.9626 9.09937 16.7646 8.90136 16.3686 8.50535L15.6314 7.76809Z"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default DashboardToolIcon;
